import { useMemo } from "react";
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";
import ISofiaHistory from "assets/i-sofia-history.js";
import { useGetCreditHistory } from "api/sofia-magic-studio";

const ModalCreditHistory = ({ onClose, isOpen, balance, ...props }) => {
  const { data: historyData, isLoading } = useGetCreditHistory({
    enabled: isOpen,
  });

  const transactions = useMemo(() => {
    return historyData?.data?.data || [];
  }, [historyData]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[370px] z-[42] bg-white rounded-[8px] border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)] overflow-hidden relative"
      >
        <div className="relative flex items-center px-4 pt-4 pb-2 border-b border-solid border-[#D8D8D9] overflow-hidden">
          <div>
            <p className="text-[13px] font-inter text-[#686A68] mb-1">
              Kredit Anda:
            </p>
            <p className="text-[17px] font-inter-semibold text-[#252526]">
              {balance?.toLocaleString("id-ID") || "0"}{" "}
              <span className="text-[20px] font-inter">kredit</span>
            </p>
          </div>

          <div className="absolute top-0 right-0 w-full flex items-center justify-end">
            <ISofiaHistory />
          </div>
        </div>

        <div className="px-4 py-2">
          <table className="w-full">
            <thead>
              <tr>
                <th className="text-[11px] text-start font-inter text-[#686A68]">
                  Detail kredit
                </th>
                <th className="text-[11px] text-center font-inter text-[#686A68]">
                  Pembelian
                </th>
                <th className="text-[11px] text-center font-inter text-[#686A68]">
                  Expired
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="3" className="text-center py-8">
                    <p className="text-[13px] text-[#808285]">
                      Memuat riwayat...
                    </p>
                  </td>
                </tr>
              ) : transactions.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center py-8">
                    <p className="text-[13px] text-[#808285]">
                      Belum ada riwayat transaksi
                    </p>
                  </td>
                </tr>
              ) : (
                transactions.map((transaction, index) => {
                  const detailKredit =
                    transaction.remaining || transaction.balance || 0;
                  const isUsed = transaction.used > 0;

                  return (
                    <tr
                      key={index}
                      className="border-b-[0.5px] border-solid border-[#DEDFDE] last:border-none"
                    >
                      <td className="py-2">
                        <div className="flex items-center justify-between">
                          <span className="text-[13px] text-[#252526]">
                            {detailKredit.toLocaleString("id-ID")}
                          </span>

                          {isUsed && (
                            <span className="text-[11px] text-[#C61025]">
                              -{transaction?.used?.toLocaleString("id-ID")}
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="py-2 text-[13px] font-inter text-center text-[#252526]">
                        {formatDate(transaction.received_at)}
                      </td>
                      <td className="py-2 text-[13px] font-inter text-center text-[#252526]">
                        {formatDate(transaction.expires_at)}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        <div className="px-4 pt-2 pb-4 border-t border-solid border-[#D8D8D9] flex justify-end">
          <Button type="secondary" size="md" text="Tutup" onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalCreditHistory isOpen={isOpen} {...props} />;
};

export default Wrapper;
